import styled from 'styled-components'

import colors from '@src/lib/Colors'

const Wrapper = styled.button`
  display: block;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  width: 34px;
  height: 34px;
  font-size: 0;
  text-indent: -9999px;
  appearance: none;
  box-shadow: none;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: ${(props) => {
    return props.isToggled ? 'rgba(255, 255, 255, 0.2)' : 'transparent'
  }};
  transition: background 0.2s ease-in-out;
  &:focus {
    background: rgba(255, 255, 255, 0.2);
  }
`

const Toggle = styled.span`
  display: block;
  position: absolute;
  top: 16px;
  left: 7px;
  right: 7px;
  height: 2px;
  background: ${(props) => props.color};
  transition: transform 0.3s;
  transform: ${(props) => {
    return props.isToggled ? 'rotate(180deg)' : null
  }};
  &:before,
  &:after {
    position: absolute;
    display: block;
    left: 0;
    width: ${(props) => {
      return props.isToggled ? '50%' : '100%'
    }};
    height: 2px;
    background-color: ${(props) => props.color};
    content: '';
  }
  &:before {
    transform-origin: top right;
    transition:
      transform 0.3s,
      width 0.3s,
      top 0.3s;
    top: ${(props) => {
      return props.isToggled ? '0' : '-5px'
    }};
    transform: ${(props) => {
      return props.isToggled
        ? 'translateX(13px) translateY(1px) rotate(45deg)'
        : null
    }};
  }
  &:after {
    transform-origin: bottom right;
    transition:
      transform 0.3s,
      width 0.3s,
      bottom 0.3s;
    bottom: ${(props) => {
      return props.isToggled ? '0' : '-5px'
    }};
    transform: ${(props) => {
      return props.isToggled
        ? 'translateX(13px) translateY(-1px) rotate(-45deg)'
        : null
    }};
  }
`

function HamburgerMenu(props) {
  const handleClick = () => {
    props.toggleSideNav()
  }

  return (
    <Wrapper isToggled={props.isToggled} onClick={() => handleClick()}>
      <Toggle color={props.color} isToggled={props.isToggled} />
    </Wrapper>
  )
}

HamburgerMenu.defaultProps = {
  color: colors.white,
  isToggled: false,
  toggleSideNav: () => {},
}

export default HamburgerMenu
